import React from 'react'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@material-ui/core'
import ReviewCard from './ReviewCard';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    overflow: 'scroll',
    height: '75%',
    padding: 20,
  };

const ReviewsModal = ({ place, reviews, open, setModalOpen, setWriteReviewData }) => {

    function handleClose() {
        setModalOpen(false)
    }

    function handleWriteReview() {
        setWriteReviewData(place)
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <DialogTitle>Reviews for: {place?.name ? place.name : ""}</DialogTitle>
            <DialogContent>
                {/* List of Reviews */
                reviews && (
                    reviews.map((rev, i) => (
                        <div key={i} >
                            <ReviewCard review={rev} />
                            <br />
                        </div>
                    ))
                )} 
            </DialogContent>
            <DialogActions>
                <Button onClick={handleWriteReview}>Write Review</Button>
                <Button onClick={handleClose}>Close</Button>
            </DialogActions>
        </Dialog>
    )
}

export default ReviewsModal